export const parseData = (
  twxData,
  selectedChartType,
  selectedDimensionType,
  selectedProperties,
  selectedMachines
) => {

  let chartDataSource = [];
  let chartKeys = [];
  selectedMachines.forEach(machine => {
    selectedProperties.forEach(property => {
      let key = machine + '_' + property
      chartKeys.push(key);
    })
  });

  if (selectedDimensionType === "Date") {
    if (twxData !== undefined) {
      twxData.forEach((item) => {
        let dataObject = {
          [item.machine +'_'+ item.property_name]: parseFloat(item.property_value),
          timestamp:formatDate(item.time)
        }
        chartDataSource.push(dataObject)
      });
    }

  } else {
    if (twxData !== undefined) {
      twxData.forEach((item) => {
        let dataObject = {
          property: item.machine +'_'+ item.property_name,
          [item.machine +'_'+ item.property_name]: parseFloat(item.property_value),
        }
        if (selectedChartType === "Doughnut Chart" ) {
          dataObject = {
            property: item.machine +'_'+ item.property_name,
            value: parseFloat(item.property_value),
          }
        }
        chartDataSource.push(dataObject)
      });
    }

  }

  return { chartDataSource, chartKeys };

};

const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  // Ensure leading zeros for single-digit months and days
  const formattedMonth = month < 10 ? "0" + month : month;
  const formattedHours = hours < 10 ? "0" + hours : hours;
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
  let formattedDay = day < 10 ? "0" + day : day;
  return formattedMonth + "/" + formattedDay + "/" + year  + ' ' + formattedHours + ":" + formattedMinutes;
};
